import { AttributeOptionDTO, parseAttributeOptionDTO } from './option-dtos.js'
import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

// --- Set Filter Option ---

export type ISetFilterOptionDTO = {
  id: number
  name: string
  description: string | null
  picture: unknown
  css_color: string | null
  product: number
}

export class SetFilterOptionDTO {
  id: number
  name: string
  description: string | null
  picture: unknown
  cssColor: string | null
  product: number

  constructor(data: ISetFilterOptionDTO) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.picture = data.picture
    this.cssColor = data.css_color
    this.product = data.product
  }
}

const validateSetFilterOptionDTO = createValidate<ISetFilterOptionDTO>()

export const parseSetFilterOptionDTO = (data: unknown): SetFilterOptionDTO => {
  validateGuard(validateSetFilterOptionDTO, data, 'SetFilterOptionDTO')
  return new SetFilterOptionDTO(data)
}

// --- Step Filter ---

export type IStepFilterDTO = {
  id: number
  name: string
  description: string | null
  input_type: string
  things?: unknown[]
  things_all?: unknown[]
}

export class StepFilterDTO {
  id: number
  name: string
  description: string | null
  inputType: string
  things: SetFilterOptionDTO[] | undefined
  thingsAll: AttributeOptionDTO[] | undefined

  constructor(data: IStepFilterDTO) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.inputType = data.input_type
    this.things = data.things?.map(parseSetFilterOptionDTO)
    this.thingsAll = data.things_all?.map(parseAttributeOptionDTO)
  }
}

const validateStepFilterDTO = createValidate<IStepFilterDTO>()

export const parseStepFilterDTO = (data: unknown): StepFilterDTO => {
  validateGuard(validateStepFilterDTO, data, 'StepFilterDTO')
  return new StepFilterDTO(data)
}
